// Texts that name the company behind the product (the "Powered by" footer), not the installation
const KEEP_PRODUCT_NAME = ['BRANDING_TEXT'];

const replaceBrand = (value, brandName) => {
  if (typeof value === 'string') return value.replace(/Chatwoot/g, brandName);
  if (Array.isArray(value))
    return value.map(item => replaceBrand(item, brandName));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        KEEP_PRODUCT_NAME.includes(key) ? item : replaceBrand(item, brandName),
      ])
    );
  }
  return value;
};

/**
 * Replaces the product name in every translation with the installation name,
 * so the texts of every language show the brand of the installation.
 */
export const applyBrandName = (messages, brandName) => {
  if (!brandName || brandName === 'Chatwoot') return messages;
  return replaceBrand(messages, brandName);
};
